<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <div
    class="qr-code"
    :data-qa="`${dataQa}_container`"
  >
    <img
      :src="QRCode"
      :data-qa="dataQa"
    >
  </div>
</template>

<script>
import qrcode from '@/app/components/qrcode';
export default {
  name: 'QRCode',
  extends: qrcode,
  props: {
    dataQa: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
</style>
